// extracted by mini-css-extract-plugin
export default {"container":"loader_container__q5eas","overlay":"loader_overlay__5Psts","title":"loader_title__qxLpx","subtitle":"loader_subtitle__pYF5I","grow":"loader_grow__pLtyC"};